import { render, staticRenderFns } from "./PesquisaAlunos.vue?vue&type=template&id=eb338ee0"
import script from "./PesquisaAlunos.vue?vue&type=script&lang=js"
export * from "./PesquisaAlunos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports